import React, { useState } from "react";
import Select from "react-select";
import { Text, View } from "@/styles/reactnative";
import { useTranslation } from "react-i18next";
import { useFetcherPublic } from "@app/hooks/fetcher";
import { useChangeLanguage } from "@app/organisms/Header/BtnLanguageChange/hooks";
import styled from "styled-components";
import {MobileCalVW, useIsMobile} from "@utils/CalVW.tsx";
import {media} from "@/styles/Qtheme.ts";

const LanguageSetting = () => {
  const { i18n, t } = useTranslation();
  const isMobile = useIsMobile();

  const [lang, setLang] = useState(i18n.language);
  useChangeLanguage(lang);

  const { data: supportLanguage } = useFetcherPublic("/system/language", false);

  // 영어와 한국어만 필터링
  const filteredLanguages = supportLanguage?.result?.result?.filter((item: any) => {
    const code = item?.code?.toLowerCase();
    return code === 'en' || code === 'ko';
  });

  const languageList = filteredLanguages?.map((item: any) => {
    return {
      value: item?.code,
      label: item?.name,
    };
  });

  const customStyles = {
    container: (provided: any) => ({
      ...provided,
      width: "100%",
      cursor: "pointer",
    }),
    control: (provided) => ({
    ...provided,
    cursor: "pointer", // 클릭 영역에 커서 적용
  }),
  };


  return (
    <View
      style={{
        width: "100%",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: '20px 10px',
        display: "flex",
        flexDirection: isMobile ? 'column' : "row",
      }}
    >

      <Contents style={{display: "flex", flexDirection: "column", gap: 16, marginBottom: isMobile ? 20 : undefined}}>
        <Text size={20} style={{ fontWeight: "500", marginBottom: isMobile ? 10 : undefined }}>
          {t("language")}
        </Text>

        <Text size={18} style={{ fontWeight: "400", color: '#F87943', lineHeight: 1  }}>
          {t("chooseYourLanguage")}
        </Text>
      </Contents>

      <SelectBox style={{ width: isMobile ? '100%' : '40%', cursor: 'pointer' }}>
        <Select
          defaultValue={languageList?.find(
            (item: any) =>
              item?.value?.toUpperCase() === i18n?.language?.toUpperCase()
          )}
          options={languageList}
          styles={customStyles}
          onChange={({ value }: any) => {
            setLang(value?.toLowerCase());
          }}
        />
      </SelectBox>
    </View>
  );
};

export default React.memo(LanguageSetting);

const Contents = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    margin-top: 20px;
    width: 100%;

    @media ${media.mobile} {
        margin-top: ${MobileCalVW(20)};
        gap: ${MobileCalVW(12)};
    }
`

const SelectBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`